// Package Imports
import ModuleIdentifierConst from 'core/common/moduleIdentifier';

// Project Imports
import resourceName from 'core/common/resourceName';
import ResourceItem from 'interfaces/resource';

const MyTaskResource: ResourceItem = {
  name: resourceName.myTask,
  identifier: ModuleIdentifierConst.TASK,
  show: `${resourceName.myTask}/show/:id`,
};

export default MyTaskResource;
